import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterPlannedStatus } from '../../../../../../model'
import { selectCockpitFilterPlannedStatus } from '../../../../../../model/selectors'
import type { TCockpitPlannedStatus } from '../../../../../../model/types'
import { CockpitSegmentedControlAccent } from '../../../../../components/cockpitSegmentedControlAccent'

import styles from './CockpitPlannedFilter.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.plannedStatus

const PLANNED_STATUS_OPTIONS: TCockpitPlannedStatus[] = ['All', 'Planned', 'Not Planned']

export const CockpitPlannedFilter = () => {
  const dispatch = useAppDispatch()
  const selectedStatus = useSelector(selectCockpitFilterPlannedStatus)

  const handleSelect = useCallback(
    (status: TCockpitPlannedStatus) => {
      dispatch(setCockpitFilterPlannedStatus(status))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <Translation text={KEYS.label} span />
      <CockpitSegmentedControlAccent stretched>
        <SegmentedControl
          useItemKeys
          selectedItem={selectedStatus}
          onItemSelect={handleSelect}
          size="small"
          variant="veneer"
          isStreatched
        >
          {PLANNED_STATUS_OPTIONS.map((status) => (
            <SegmentedControl.Item key={status} itemKey={status}>
              <span>{status}</span>
            </SegmentedControl.Item>
          ))}
        </SegmentedControl>
      </CockpitSegmentedControlAccent>
    </div>
  )
}
